export default "__VITE_ASSET__DmSxiQ5r__"